export function buildPublicSeatsRequest(productApiName, seatsQuantity, currencyCode, term) {
  return {
    products: [{
      productApiName,
      skuQuantity: seatsQuantity
    }],
    quantityPacks: [],
    currencyCode,
    commitmentTerm: term,
    paymentTerm: term
  };
}